module.exports = __webpack_public_path__ + "static/img/auth-bg.489b89c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/auth-bg.png
// module id = d7Qf
// module chunks = 36